/* eslint-disable react/jsx-boolean-value */
import { LoadingButton } from '@mui/lab';
import {
  Box,
  CircularProgress,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useComposeAddress from 'api/locationsCategories/address/useComposeAddress';
import useGetAllArrowTypes from 'api/locationsCategories/address/useGetAllArrowTypes';
import useAllCellDecreaseTypes from 'api/locationsCategories/address/useGetAllDecreaseTypes';
import useGetAllLabelTypes from 'api/locationsCategories/address/useGetAllLabelTypes';
import React, { useEffect, useState } from 'react';

const ComposeAddressModal = props => {
  const { guid, type } = props;

  const [composeLoading, composeAddress] = useComposeAddress();
  const [arrowsLoading, arrows, getAllArrowTypes] = useGetAllArrowTypes();
  const [decreasesLoading, decreases, getAllCellDecreaseTypes] =
    useAllCellDecreaseTypes();
  const [labelsLoading, labels, getAllLabelTypes] = useGetAllLabelTypes();

  const [selectedArrow, setSelectedArrow] = useState('');
  const [selectedDecrease, setSelectedDecrease] = useState('');
  const [selectedLabel, setSelectedLabel] = useState('');
  const [isMixed, setIsMixed] = useState(false);

  useEffect(() => {
    getAllArrowTypes();
    getAllCellDecreaseTypes();
    getAllLabelTypes();
  }, []);

  useEffect(() => {
    if (arrows) {
      setSelectedArrow(arrows[1].key);
    }
  }, [arrows]);

  useEffect(() => {
    if (decreases) {
      setSelectedDecrease(decreases[1].key);
    }
  }, [decreases]);

  useEffect(() => {
    if (labels) {
      setSelectedLabel(labels[0].key);
    }
  }, [labels]);

  const handleClick = () => {
    composeAddress(
      {
        guid,
        type,
        arrow: selectedArrow,
        decreaseType: selectedDecrease,
        labelType: selectedLabel,
        isMixed,
      },
      props.refreshData,
    );
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.closeHandler();
        setSelectedArrow('');
        setSelectedDecrease('');
        setSelectedLabel('');
        setIsMixed(false);
      }}
      sx={{ direction: 'rtl' }}
      onKeyDown={handleKeyDown}
    >
      <DialogTitle>ایجاد آدرس</DialogTitle>

      <DialogContent>
        {arrowsLoading || decreasesLoading || labelsLoading ? (
          <Box
            sx={{ display: 'flex', justifyContent: 'center', minWidth: 300 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ width: 320 }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="arrow-selection">جهت</InputLabel>
              <Select
                labelId="arrow-selection"
                id="arrow-selection-standard"
                value={selectedArrow}
                onChange={e => setSelectedArrow(e.target.value)}
              >
                {arrows
                  ? arrows.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        sx={{ justifyContent: 'flex-end' }}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="descrease-selection">نوع خروج</InputLabel>
              <Select
                labelId="descrease-selection"
                id="descrease-selection-standard"
                value={selectedDecrease}
                onChange={e => setSelectedDecrease(e.target.value)}
              >
                {decreases
                  ? decreases?.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        sx={{ justifyContent: 'flex-end' }}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="labelType-selection">نوع برچسب</InputLabel>
              <Select
                labelId="labelType-selection"
                id="labelType-selection-standard"
                value={selectedLabel}
                // defaultValue={labels[1]}
                onChange={e => setSelectedLabel(e.target.value)}
              >
                {labels
                  ? labels.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        sx={{ justifyContent: 'flex-end' }}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
              <InputLabel id="labelType-selection">فضای ترکیبی؟</InputLabel>
              <Select
                labelId="labelType-selection"
                id="labelType-selection-standard"
                value={isMixed}
                onChange={e => setIsMixed(e.target.value)}
              >
                <MenuItem
                  key={true}
                  value={true}
                  sx={{ justifyContent: 'flex-end' }}
                >
                  بله
                </MenuItem>
                <MenuItem
                  key={false}
                  value={false}
                  sx={{ justifyContent: 'flex-end' }}
                >
                  خیر
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={composeLoading}
          //   disabled={!itemName}
          onClick={handleClick}
        >
          تایید
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={composeLoading}
          onClick={() => {
            props.closeHandler();
            setSelectedArrow('');
            setSelectedDecrease('');
            setSelectedLabel('');
            setIsMixed(false);
          }}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ComposeAddressModal;
